import React from 'react';
import { FactboxBase } from '../common/utils';
import { SingleColumnFactboxProps } from './single-column-factbox-types';
import { SingleColumnSection } from './single-column-utils';

export const SingleColumnFactbox = (props: SingleColumnFactboxProps) => {
  const { options } = props;
  const { section } = options;
  return (
    <FactboxBase
      title={options.title}
      subtitle={options.subtitle}
      footer={options.footer}
      fontSize={options.fontSize}
    >
      <SingleColumnSection section={section} />
    </FactboxBase>
  );
};
